import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import BaseButton from 'src/common/components/base-button';
import { splitCamel } from 'src/common/helpers/string-helper';
import { ITender } from 'src/common/interfaces/dtos/ITender';
import { ITenderGroup } from 'src/common/interfaces/dtos/ITenderGroup';
import { AppState } from 'src/common/redux/configure-store';
import { getCardData } from 'src/devices/payment/get-card-details';
import { findMatchingTenderInStore } from '../business-logic/handle-tender-payment';
import { styles } from './tender-group-view-styles';

const TenderGroupTenderButtons = ({
  tenderGroup,
  disabled,
  handleTenderClick,
  selectedTender,
  horizontalBtnAlignment,
}: TenderGroupTenderButtonsProps): JSX.Element => {
  const classes = styles();
  const hasCardData = useSelector((state: AppState) => state.pinPad.hasCardData);
  return (
    <Grid item data-testid='tender-buttons'>
      {tenderGroup.tenders
        .filter(t => t.isActive)
        .map(tender => {
          const testId = `tender-button-${tender.description}`;
          let buttonClasses = horizontalBtnAlignment ? classes.tenderButtonSmallForm : classes.tenderButton;
          // when do we show it as selected???
          if (selectedTender?.id === tender.id) {
            buttonClasses += ` ${classes.tenderButtonSelected}`;
          }

          if (hasCardData) {
            const swipedTender = findMatchingTenderInStore(getCardData());
            if (tender.id === swipedTender?.id) {
              buttonClasses += ` ${classes.preSwipedTender}`;
            }
          }

          return (
            <BaseButton
              key={tender.id}
              buttonType='white'
              data-testid={testId}
              className={buttonClasses}
              onClick={() => handleTenderClick(tender)}
              disabled={disabled}
            >
              <Typography className={classes.labelText}>
                {/* Formatted tender name string */}
                {splitCamel(tender.description)?.replace(/_/g, '')}
              </Typography>
            </BaseButton>
          );
        })}
    </Grid>
  );
};

interface TenderGroupTenderButtonsProps {
  tenderGroup: ITenderGroup;
  disabled: boolean;
  handleTenderClick: (tender: ITender) => void;
  selectedTender?: ITender;
  horizontalBtnAlignment: boolean;
}

export default TenderGroupTenderButtons;
